/**
 * MountAsBlueprintDialog
 *
 * Shown when a folder picked for mounting turns out to hold a valid
 * jamsql-blueprint.json. Offers two choices:
 *   - Mount as blueprint → markFolderAsBlueprint + open the blueprint tab
 *   - Mount as plain folder → the normal addMountedFolder path
 */
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';

type MountAsBlueprintDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onMountAsBlueprint: () => void;
  onMountAsPlainFolder: () => void;
};

export function MountAsBlueprintDialog({
  open,
  onOpenChange,
  onMountAsBlueprint,
  onMountAsPlainFolder,
}: MountAsBlueprintDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="mount-as-blueprint-dialog">
        <DialogHeader>
          <DialogTitle>Mount as Database Blueprint?</DialogTitle>
          <DialogDescription>
            This folder is a Jam SQL Database Blueprint. Mount it as a blueprint to
            get refresh / apply / sync, git, and the blueprint tab — or mount it as a
            plain folder to just browse its .sql files.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2">
          <Button
            type="button"
            variant="outline"
            onClick={onMountAsPlainFolder}
            data-testid="mount-as-plain-folder"
          >
            Mount as plain folder
          </Button>
          <Button
            type="button"
            onClick={onMountAsBlueprint}
            data-testid="mount-as-blueprint-confirm"
          >
            Mount as blueprint
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
